import React, { useEffect, useMemo } from "react";
import cn from "classnames";
import { useHistory, useLocation } from "react-router-dom";

import { useAppSelector } from "@/redux/store";
import { selectAuthBgImages } from "@/util/selectors";
import { useRouteSlug } from "@/hooks";
import { normalizePathFromQuery } from "@/utils";
import "./style.scss";

type AuthLayoutProps = {
  className?: string;
  children: React.ReactNode;
  signUp?: boolean;
};

const AuthMobileLayout: React.FC<AuthLayoutProps> = ({
  className,
  children,
  signUp = false
}) => {
  const history = useHistory();
  const routeSlug = useRouteSlug();
  const { search } = useLocation();
  const { signInPageTopBg, signUpPageTopBg } =
    useAppSelector(selectAuthBgImages);

  const redirectPath = useMemo(() => {
    const raw = new URLSearchParams(search).get("redirect") || "";
    return normalizePathFromQuery(raw);
  }, [search]);

  useEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, []);

  const handleCloseAuthFlow = (e: React.MouseEvent) => {
    e.preventDefault();
    if (redirectPath.startsWith("my-account/")) {
      history.replace(`/${routeSlug}/`);
    } else {
      history.replace(
        redirectPath ? `/${routeSlug}/${redirectPath}` : `/${routeSlug}/`
      );
    }
  };

  const bgImage = signUp ? signUpPageTopBg : signInPageTopBg;
  return (
    <div className={cn("root_auth_mobile_layout", className)}>
      <span className="auth_cross_icon" onClick={handleCloseAuthFlow} />
      <header className="hero"></header>

      {bgImage && (
        <img
          src={bgImage}
          alt="Smile More Loyalty Program"
          className="heroImage"
        />
      )}
      <main className="authCard" role="main">
        {children}
      </main>
    </div>
  );
};

export default AuthMobileLayout;
